<template>
    <div class="row row-sezione">
        <div class="col-12">
            <h3>
                <b>
                    {{this.type}}
                </b>
            </h3>
            <div v-if="this.zone">{{this.zone.traduzione.nome}}</div>
            <div>{{this.nome_locale}}</div>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

export default {
    name: "Lv1Fiera",
    props: ['configurazioni', 'currType'],
    computed: {
        zone: function () {
            if (this.f_modalita_fiera) {
                return this.service_points.find((zone) => {
                    return zone.id === this.id_punto_di_servizio;
                });
            }

            return null;
        },
        type: function () {
            try {
                return this.getServiceInfo(this.type_default, this.configurazioni.dil.label_tipologia).nome.toUpperCase();
            } catch (e) {
                return null;
            }
        },
        ...mapState('restaurant', {
            f_modalita_fiera: state => state.f_modalita_fiera,
            nome_locale: state => state.locale.nome_locale,
            service_points: state => state.punti_di_servizio
        }),
        ...mapState('order', {
            type_default: state => state.type_default,
            id_punto_di_servizio: state => state.id_punto_di_servizio
        }),
        ...mapGetters('restaurant', {
            getServiceInfo: 'serviceInfo'
        })
    }
}
</script>
